/**
 * Enum representing different filebox operations.
 */
export enum FileboxOperationEnum {
	/**
	 * Represents a copy operation
	 */
	COPY = 'copy',

	/**
	 * Represents a move operation
	 */
	MOVE = 'move',

	/**
	 * Represents an archive operation
	 */
	ARCHIVE = 'archive',

	/**
	 * Represents a delete operation
	 */
	DELETE = 'delete',
}
